import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {OptionService} from '../../shared/services/option/option.service';
import {WordDispComponent} from '../../shared/components/word-disp/word-disp.component';
import {Router} from "@angular/router";
import {DynamicComponentService} from "../../shared/services/dynamic-component/dynamic-component.service";
import {GlobalEventService} from "../../shared/services/global-event/global-event.service";
import {LayoutMgrService} from "../../shared/services/layout-mgr/layout-mgr.service";

@Component({
  selector: 'app-homonym-disp',
  template: `
    <article class="keyword">
      <table>
        <tr class="sub top">
          <td *ngFor="let cs of word.wordStruct"
              class="{{ GetSeungjoClass(cs) }}">{{ GetSaseungTxt(cs) }}</td>
        </tr>
        <tr class="main">
          <td *ngFor="let cs of word.wordStruct; let idx = index"
              class="{{ GetCharClass(cs) }} {{ GetHightlightClass(idx) }}">{{ GetCharTxt(cs) }}</td>
          <td *ngIf="word.idxHomonym > 0"
              class="idx-homonym">{{ word.idxHomonym }}</td>
        </tr>
        <!-- tr class="sub bottom">
          <td *ngFor="let cs of word.wordStruct"
              class="{{ GetSeungjoClass2(cs) }}"></td>
        </tr -->
      </table>

    </article>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomonymDispComponent extends WordDispComponent {

  constructor(
    public router: Router,
    public dynamicSvc: DynamicComponentService,
    public lm: LayoutMgrService,
    protected cdRef: ChangeDetectorRef,
    protected option: OptionService,
    protected globalEventSvc: GlobalEventService,
  ) {
    super(router, dynamicSvc, lm, cdRef, option, globalEventSvc);
  }

}
